<template>
  <div class="flex flex-col gap-2.5">
    <div
      @click="model = !model"
      class="flex cursor-pointer items-center gap-2.5"
    >
      <input
        type="checkbox"
        :name="id"
        :id="id"
        v-model="model"
        class="h-3.75 w-3.75 cursor-pointer appearance-none border border-black bg-transparent transition-colors duration-400 group-hover:cursor-pointer checked:bg-black"
        @click.stop
      />
      <label
        :for="id"
        class="w-full cursor-pointer text-xs/[120%] group-hover:cursor-pointer xl:text-sm/[115%]"
        @click.prevent
      >
        {{ label }}
      </label>
    </div>
    <span v-if="error" class="animate-fade-in text-xs text-red-600">
      {{ error }}
    </span>
  </div>
</template>

<script setup lang="ts">
interface Props {
  id: string
  label: string
  error?: string
}

defineProps<Props>()
const model = defineModel<boolean>()
</script>
